import { createFileRoute } from "@tanstack/react-router";
import { TopicIndex, topicAnswer } from "@/components/TopicIndex";
import { getTopicIndex } from "@/lib/topics.functions";
import { getTopic } from "@/lib/topics-config";
import { buildTopicHead } from "@/lib/topic-head";
import { validateTableSearch } from "@/lib/table-state";

const def = getTopic("mpg-comparison")!;

export const Route = createFileRoute("/mpg-comparison")({
  validateSearch: (search: Record<string, unknown>) => validateTableSearch(search),
  loader: () => getTopicIndex({ data: { slug: "mpg-comparison" } }),
  head: ({ loaderData, match }) =>
    buildTopicHead(
      def,
      loaderData ?? null,
      loaderData ? topicAnswer(def, loaderData) : "",
      match.search,
    ),
  component: TopicPage,
});

function TopicPage() {
  const data = Route.useLoaderData();
  if (!data || data.entries.length === 0) {
    return (
      <div className="mx-auto max-w-3xl px-4 py-20 text-center">
        <h1 className="text-2xl font-bold text-foreground">{def.h1}</h1>
        <p className="mt-4 text-muted-foreground">This chart is being rebuilt. Check back shortly.</p>
      </div>
    );
  }
  return <TopicIndex def={def} data={data} />;
}
